// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Ss-z","tooltipWrapper":"Ts-z","icon":"Us-z","tooltip":"Vs-z","content":"Ws-z"};